/**
 * Interactive questionnaire tools — pause the agent loop for user input.
 */

import { Schema } from "firebase/ai";
import { countTotalHeads } from "../guests/heads";
import {
  defaultSeatingSetupAnswers,
  type SeatingSetupAnswers,
} from "@amazing-wedding/shared-types";
import type { PendingSeatingSetupQuestionnaire } from "../types";
import type { PlannerTool } from "./registry";
import type { ToolContext } from "../types";

export const SEATING_SETUP_QUESTIONNAIRE_TOOL = "ask_seating_setup_questionnaire";

export type SeatingSetupQuestionnairePayload = Omit<PendingSeatingSetupQuestionnaire, "requestId">;

export function buildSeatingSetupQuestionnairePayload(
  ctx: ToolContext,
  intro?: string | null,
): SeatingSetupQuestionnairePayload {
  const guests = ctx.guests();
  const totalHeads = countTotalHeads(guests);
  return {
    toolName: SEATING_SETUP_QUESTIONNAIRE_TOOL,
    intro: intro ?? undefined,
    totalHeads,
    defaults: defaultSeatingSetupAnswers(totalHeads),
  };
}

export const questionnaireTools: PlannerTool[] = [
  {
    declaration: {
      name: SEATING_SETUP_QUESTIONNAIRE_TOOL,
      description:
        "Show a fixed seating-setup form to the couple before generating a layout. REQUIRED on an empty active plan before calling setup_seating_plan. Collects table size, count, VIP table, guest assignment preferences.",
      parameters: Schema.object({
        properties: {
          intro: Schema.string({
            description:
              "Optional one-sentence context shown above the form. Write in the same language as your replies to the couple.",
          }),
        },
        optionalProperties: ["intro"],
      }),
    },
    destructive: false,
    interactive: true,
    describe: (_args, ctx) => ctx.translate("seating.questionnaire.title"),
    execute: async () => {
      throw new Error("Interactive tool — handled by agent loop.");
    },
  },
];

export type { SeatingSetupAnswers };
